import { Pipe, PipeTransform } from '@angular/core';
import {environment} from "../environments/environment";

@Pipe({
    name: 'unitOverviewLink'
})
export class UnitOverviewLinkPipe implements PipeTransform {

    transform(vin: string| number): string {
        if (!vin) return '#';

        // Combine the environment URL with the VIN
        return `${environment.externalLinks.unitOverview}${vin}`;
    }

}
